import { useStyles } from '@webapps/styles';
import { useState, useEffect } from 'react';
import { PaginationNumbers, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { getRelationsByCFA, searchOpcoRecords } from '@webapps/business';
import FiltersRecords from './components/FiltersRecords';
import { useFormik } from 'formik';
import { Grid } from '@material-ui/core';
import RecordCard from './components/RecordCard';
import { useLocation, useHistory } from 'react-router-dom';
import RecordSidebar from './components/RecordSidebar';
import Nodata from 'components/NoData';
import theme from './theme';

const {
  images: { RecordsImage }
} = theme

const Records = () => {
  const { classes, global, css, cx } = useStyles();

  const { idUser } = useAuth();
  const { state } = useLocation();
  const { replace, location } = useHistory();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [clearState, setClearState] = useState(false);

  useEffect(() => {
    setPage(state?.page || 1);
  }, [state?.page]);

  useEffect(() => {
    if (clearState) {
      replace({ ...location, state: {} });
      formik.setValues({
        ...formik.values,
        studentName: "",
        opcoStatus: "",
      });
      setClearState(false);
    }
  }, [clearState]);

  const formik = useFormik({
    initialValues: {
      school: "",
      trainingLabel: "",
      studentName: state?.name || "",
      opcos: "",
      opcoStatus: state?.status || "",
      contractStatus: "",
    },
  });

  const { data: { content: relationsList = [] } = {} } = useQuery(getRelationsByCFA, {
    key: ['relationsList'],
    variables: { id: idUser, size: 100, page: 0 },
    keepPreviousData: true
  });

  const { data: { content: records = [], totalElements } = {}, refetch, isLoading } = useQuery(searchOpcoRecords, {
    key: ['opcoRecords', size, page, formik?.values],
    variables: {
      id: idUser,
      schoolsId: formik?.values?.school?.id,
      trainingLabel: formik?.values?.trainingLabel,
      studentName: formik?.values?.studentName
        ? formik.values.studentName.trim().split(/\s+/).join(',')
        : null,
      opcos: formik?.values?.opcos,
      opcoStatus: formik?.values?.opcoStatus,
      contractStatus: formik?.values?.contractStatus,
      size,
      page: page - 1
    },
  });

  useEffect(() => {
    setPage(1)
  }, [formik.values]);

  useEffect(() => {
    if (selectedRecord && records?.length > 0) {
      const updatedRecord = records.find((r) => r.id === selectedRecord.id);
      if (updatedRecord) {
        setSelectedRecord(updatedRecord); // Update with fresh record data
      }
    }
  }, [records]);

  return (
    <div className={(isLoading || totalElements > 0) ? global.container : global.containerNoScroll}>

      {/* <div className={totalElements > 0 ? global.container : global.containerNoScroll}> */}
      <div className={global.containerContent} >
        <FiltersRecords formik={formik} schools={relationsList.map(item => item.school).filter(school => school)} refetch={refetch} />
        <Grid className={cx(global.paper)} container>
          {isLoading ? (
            [...Array(size/2)].map((_, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}>
                <RecordCard isLoading={isLoading} info={{}} setSelectedRecord={setSelectedRecord} />
              </Grid>
            ))
          ) : records?.length > 0 ? (
            records.map((record) => (
              <Grid key={record.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }}  >
                <RecordCard info={record} refetch={refetch} toOpen={record.id === state?.id && true} setSelectedRecord={setSelectedRecord} />
              </Grid>
            ))
          ) : (
            <Nodata
              contentWidth="20%"
              borderRadius='36px'
              padding="0px 20px 20px 0px"
              title="Aucun dossier trouvé"
              description="Essayez d'ajuster vos filtres de recherche ou vérifiez que vos connexions aux organismes de formation sont actives."
              image={RecordsImage}
            />
          )}
        </Grid>
        {(records?.length > 0) && (
          <PaginationNumbers
            onChange={(newPage) => setPage(newPage)}
            page={page}
            pageCount={size}
            totalCount={totalElements}
          />
        )}
      </div>
      <RecordSidebar open={selectedRecord ? true : false} handleClose={() => { setClearState(true), setSelectedRecord(null) }} opcoRecord={selectedRecord} refetch={refetch} />
    </div>
  );
};

export default Records;